import React from 'react';
import PropTypes from 'prop-types';
import Fade from 'react-reveal/Fade';
import RectangularListElem from 'components/Components/Includes/RectangularListElem';
import moment from 'moment';
import DefaultOffer from 'components/Components/Sections/DefaultOffer';
import { isEmpty } from 'lodash';

function Offers({ hotel, headerPhoneNumber })
{
    return (
        <section id="offers" className="tw-py-10 lg:tw-py-20 tw-px-4 tw-bg-gray-300">
            <div className="xl:tw-container tw-text-center">
                <Fade bottom>
                    <h2 className="font-arapey tw-text-4xl lg:tw-text-5xl tw-font-normal tw-text-gray-700 leading-12">Offers</h2>
                </Fade>

                <div className="tw-mt-16 lg:tw-mt-16">
                    { !isEmpty(hotel.hotelValidPromotions) ? (
                        <>
                            {hotel.hotelValidPromotions.map((promo, id) => (
                                <RectangularListElem
                                    key={id}
                                    image={
                                        hotel.hotelPictures.find(e => e.id === promo.hotel_picture_id)
                                            ? hotel.hotelPictures.find(e => e.id === promo.hotel_picture_id).path
                                            : '/assets/placeholder/no-image.jpg'
                                    }
                                    title={promo.name}
                                    titleType="promo"
                                    goingTo={hotel.name}
                                    id={hotel.id}
                                    type="hotel"
                                    description={promo.description}
                                    travelWin={`${promo.travel_window_from && moment(promo.travel_window_from).format('MMM D, YYYY')} - ${promo.travel_window_from && moment(promo.travel_window_from).format('MMM D, YYYY')}`}
                                    bookingWin={`${promo.booking_window_from && moment(promo.booking_window_from).format('MMM D, YYYY')} - ${promo.booking_window_from && moment(promo.booking_window_from).format('MMM D, YYYY')}`}
                                    blackoutDates={promo.black_out_dates_policy}
                                    termsConditions={promo.terms_and_conditions}
                                    headerPhoneNumber={headerPhoneNumber}
                                    headerLogo={hotel.logo}
                                />
                            ))
                            }
                        </>
                    )
                        : <DefaultOffer />}
                </div>
            </div>
        </section>
    );
}

Offers.propTypes = {
    hotel: PropTypes.object.isRequired,
    headerPhoneNumber: PropTypes.string,
};

export default Offers;
